
import { defineComponent, ref } from 'vue'

import {
  getAmountList,
  getCategoryGoodsCount,
  getCategoryGoodsSale,
  getCategoryGoodsFavor,
  getAddressGoodsSale
} from '@/service/data/data'
import { IDataType } from '@/components/page-charts/types/type'

import BaseCard from '@/base-ui/card'
import { PieChart, RoseChart, LineChart, BarChart, MapChart } from '@/components/page-charts'
import StatisticalPanel from '@/components/statistical-panel'

export default defineComponent({
  name: 'dashboard',
  components: {
    PieChart,
    BaseCard,
    RoseChart,
    LineChart,
    BarChart,
    MapChart,
    StatisticalPanel
  },
  setup() {
    const topPanelData = ref<any>()
    const categoryGoodsCount = ref<IDataType[]>([])
    const categoryGoodsSale = ref<{ xLabels: string[]; yValues: any[] }>({
      xLabels: [],
      yValues: []
    })
    const categoryGoodsFavor = ref<{ xLabels: string[]; yValues: any[] }>({
      xLabels: [],
      yValues: []
    })
    const addressGoodsSale = ref<IDataType[]>([])

    getAmountList().then((res) => {
      topPanelData.value = res.data
    })

    getCategoryGoodsCount().then((res) => {
      categoryGoodsCount.value = res?.data?.map((item: any) => ({
        ...item,
        value: item.goodsCount
      }))
    })

    getCategoryGoodsSale().then((res) => {
      categoryGoodsSale.value.xLabels = res?.data?.map((item: any) => item.name)
      categoryGoodsSale.value.yValues = res?.data?.map((item: any) => item.goodsCount)
    })

    getCategoryGoodsFavor().then((res) => {
      categoryGoodsFavor.value.xLabels = res?.data?.map((item: any) => item.name)
      categoryGoodsFavor.value.yValues = res?.data?.map((item: any) => item.goodsFavor)
    })

    getAddressGoodsSale().then((res) => {
      addressGoodsSale.value = res?.data?.map((item: any) => ({
        name: item.address,
        value: item.count
      }))
    })

    return {
      categoryGoodsCount,
      categoryGoodsSale,
      categoryGoodsFavor,
      addressGoodsSale,
      topPanelData
    }
  }
})
